import { DisclosureButton } from "@headlessui/react";
import { FC, PropsWithChildren } from "react";

export const FAQButton: FC<PropsWithChildren> = ({ children }) => {
  return (
    <DisclosureButton className="py-2 bg-jooalan-primary-60/50 hover:bg-jooalan-primary-60/90 rounded px-4 w-full text-left mb-2 text-[12pt]">
      {children}
    </DisclosureButton>
  );
};